import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DestroyBase } from '../../../../shared/base-classes/destroy-component-base';
import {
  TableColumn,
  TableComponent,
} from '../../../../shared/components/table/table.component';
import { ManageDuplicatesService } from '../../services/manage-duplicates.service';
import {
  DuplicateIdentityGroup,
  DuplicateMembersResponse,
} from '../../models/duplicate-business';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-manage-duplicate-items',
  standalone: true,
  imports: [CommonModule, TableComponent],
  templateUrl: './manage-duplicate-items.component.html',
  styleUrl: './manage-duplicate-items.component.scss',
})
export class ManageDuplicateItemsComponent
  extends DestroyBase
  implements OnInit
{
  private duplicateService = inject(ManageDuplicatesService);

  @Input({ required: true }) group!: DuplicateIdentityGroup;
  @Output() viewDetails = new EventEmitter<string>();

  tableColumns: TableColumn[] = [
    { header: 'Business Name' },
    { header: 'Record ID' },
    { header: 'Email' },
    { header: 'City / State' },
    { header: 'Created By' },
    { header: 'Actions', style: { 'text-align': 'right' } },
  ];

  ngOnInit(): void {
    if (!this.group.records || this.group.records.length === 0) {
      this.fetchMembers(1);
    }
  }

  fetchMembers(page: number): void {
    if (page === 1) {
      this.group.isLoadingMembers = true;
    } else {
      this.group.isLoadingMore = true;
    }

    const pageSize = this.group.membersPageSize || 5;

    this.duplicateService
      .getIdentityMembers(
        this.group.identity_type,
        this.group.identity_value,
        page,
        pageSize,
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: DuplicateMembersResponse) => {
          if (page === 1) {
            this.group.records = res.records;
          } else {
            this.group.records = [
              ...(this.group.records || []),
              ...res.records,
            ];
          }
          this.group.membersPage = res.page;
          this.group.membersTotal = res.total;
          this.group.hasMoreMembers =
            (this.group.records?.length || 0) < res.total;
          this.group.isLoadingMembers = false;
          this.group.isLoadingMore = false;
        },
        error: (err: unknown) => {
          console.error('Error loading identity members', err);
          this.group.isLoadingMembers = false;
          this.group.isLoadingMore = false;
        },
      });
  }

  loadMoreMembers(): void {
    if (this.group.isLoadingMore || !this.group.hasMoreMembers) return;
    const nextPage = (this.group.membersPage || 1) + 1;
    this.fetchMembers(nextPage);
  }

  onViewDetails(uniqueId: string): void {
    this.viewDetails.emit(uniqueId);
  }

  cleanUsername(username?: string): string {
    if (!username) return 'System';
    return username.split('#')[0].trim();
  }
}
